import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/autorizaciones/relations";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: "10px",
    modelsLiquidations: [],
    coments: [],
    concepts: [],
    costCenters: [],
    open: false,
    mode: "Agregrar modelos de liquidación",
    new: {},
    edit: {},
    editRelation: {},
    itemDelete: null,
    openDelete: false,
    showCard: false,
    showTable: false,
    openFormRelation: false,
    modeFormRelation: "",
  },

  mutations: {
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setOpen(state, data) {
      state.open = data;
    },
    setComents(state, data) {
      state.coments = data;
    },
    setConcepts(state, data) {
      state.concepts = data;
    },
    setCostCenters(state, data) {
      state.costCenters = data;
    },

    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setModelsLiquidations(state, data) {
      state.modelsLiquidations = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setShowCard(state, data) {
      state.showCard = data;
    },
    setShowTable(state, data) {
      state.showTable = data;
    },
    setOpenFormRelation(state, data) {
      state.openFormRelation = data;
    },
    setModeFormRelation(state, data) {
      state.modeFormRelation = data;
    },
    setEditRelation(state, data) {
      state.editRelation = data;
    },
  },
  actions: {
    async getLiquidationModels(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getLiquidationModels();
          state.commit("setModelsLiquidations", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getRolComents(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getRolesComents(
            state.state.edit
          );
          state.commit("setComents", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getRolConcepts(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getRolesConcepts(
            state.state.edit
          );
          state.commit("setConcepts", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getRolCostCenters(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getRolesCostCenters(
            state.state.edit
          );
          state.commit("setCostCenters", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async addRolComent(state) {
      try {
        const response = await state.state.service.addRolesComment(
          state.state.new
        );
        return true;
      } catch (error) {
        throw error;
      }
    },
    async addRolConcept(state) {
      try {
        const response = await state.state.service.addRolesConcepts(
          state.state.new
        );
        return true;
      } catch (error) {
        throw error;
      }
    },
    async addRolCostCenter(state) {
      try {
        const response = await state.state.service.addRolesCostCenters(
          state.state.new
        );
        const newItem = response.data;
        return true;
      } catch (error) {
        throw error;
      }
    },

    async deleteRolComent(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteRolesComent(state.state.itemDelete)
            .then(() => {
              let options = state.state.coments;

              options = options.filter((option) => {
                return option.id !== state.state.itemDelete.id;
              });

              state.commit("setComents", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteRolConcept(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteRolesConcept(state.state.itemDelete)
            .then(() => {
              let options = state.state.concepts;

              options = options.filter((option) => {
                return option.id !== state.state.itemDelete.id;
              });

              state.commit("setConcepts", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteRolCostCenter(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteRolesCostCenter(state.state.itemDelete)
            .then(() => {
              let options = state.state.costCenters;
              options = options.filter((option) => {
                return option.id !== state.state.itemDelete.id;
              });

              state.commit("setCostCenters", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
